import { getAPIFromDomain } from "../lib/api";

export const fetchPickSheetPdfs = async (shipmentIds: string[]): Promise<File> => {
  const api = getAPIFromDomain("november");
  const url = `/pick-sheets/generate-pick-sheets`;
  const response = await api.post(url, { shipment_ids: shipmentIds });
  return response.data as File;
};

export const fetchOutboundWorkOrders = async (shids: string[]): Promise<{ id: string; shipment_number: string }[]> => {
  const api = getAPIFromDomain("november");
  const url = `/outbound-work-order`;
  const response = await api.get(url, { params: { shipment_numbers: shids, page: 1, limit: shids.length } });
  return response.data.items;
};
